import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export const emptyPartner = { company_name: "", vat_number: "", contact_email: "", phone: "", address: "", iban: "", shipping_cost: 0, pickup: false };

const FIELDS = [
  ["company_name", "Ragione sociale"], ["vat_number", "Partita IVA"], ["contact_email", "Email di contatto"], ["phone", "Telefono"],
  ["address", "Indirizzo sede (per il ritiro)"], ["iban", "IBAN per i riversamenti"], ["shipping_cost", "Costo spedizione fisso (€)"],
];

export function PartnerForm({ initial = emptyPartner, onSubmit, submitLabel }) {
  const [f, setF] = useState(initial);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await onSubmit({ ...f, shipping_cost: parseFloat(f.shipping_cost || 0) });
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid="partner-form">
      {FIELDS.map(([k, l]) => (
        <div key={k}>
          <Label className="text-xs text-slate-400">{l}</Label>
          <Input data-testid={`partner-${k}`} type={k === "shipping_cost" ? "number" : "text"} step="0.01" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1 bg-[#1C1F2C]" />
        </div>
      ))}
      <div className="flex items-center gap-3 pt-6">
        <Switch data-testid="partner-pickup" checked={f.pickup} onCheckedChange={(v) => setF({ ...f, pickup: v })} />
        <span className="text-sm text-slate-300">Offro il ritiro in sede</span>
      </div>
      <button data-testid="partner-submit" disabled={busy} className="flex h-11 items-center justify-center gap-2 rounded-xl bg-amber-500 font-semibold text-black hover:bg-amber-400 disabled:opacity-50 sm:col-span-2">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} {submitLabel}
      </button>
    </form>
  );
}
